import {ScheduleTypes} from "./Reducer"
import API from '../../Api'
import {getMeetingsToReplace, getProgressValues, getStateParams, getUserSelection} from '../../Store'
import {CommonTypes} from "../../Redux/CommonTypes";
import {Analytics} from "../../Common/Analytics";
import {setLanguage} from "../Identify/Actions";
import {getSafely, valueOrDefault} from "@tomeravni/easybizy-js-common/common";

export const setStateParams = (token, service_id, employee_id, day_part, date, mobile,
                               validation_hash, existing_mode, quantities, gender, s_category) => {
    return {
        type: ScheduleTypes.SET_STATE_PARAMS,
        token, service_id, employee_id, day_part, date, mobile, validation_hash,
        existing_mode,
        quantities,
        gender,
        s_category
    }
};

export const setSessionToken = (sessionToken, paymentUrl) => ({
    type: ScheduleTypes.SET_SESSION,
    s_token: sessionToken,
    paymentUrl
})


export const configLoading = () => ({
    type: ScheduleTypes.CONFIG_REQUEST,
});

export const configSuccess = config => ({
    type: ScheduleTypes.CONFIG_SUCCESS,
    config
});

export const configError = error => ({
    type: ScheduleTypes.CONFIG_ERROR,
    error
});


export const getConfig = (context, customerToken, callback = null) => async dispatch => {
    dispatch(configLoading());
    const response = await API.getMeetingReservationConfig(context, customerToken);
    if (response.ok) {
        dispatch(configSuccess(response.data));
        if (response.data.FacebookPixel && response.data.FacebookPixel.length > 3) {
            Analytics.setFacebookPixel(response.data.FacebookPixel)
            const customer = getSafely(['data', 'Customer'], response, {});
            Analytics.trackFacebookEvent('online-scheduling-loaded', {
                customer: (`${customer.CustomerId || ''} - ${customer.FirstName || ''}  ${customer.LastName || ''}`).trim(),
            });
        }

        let forcedLanguage = response.data.ForceLanguage;
        if (forcedLanguage && ['he-IL', 'en-US'].includes(forcedLanguage || '')) {
            dispatch(setLanguage(forcedLanguage));
        }
    } else {
        dispatch(configError(response.error));
    }

    if (callback) {
        callback(response.error, response.data);
    }
};


export const configWithServicesLoading = () => ({
    type: ScheduleTypes.CONFIG_WITH_SERVICES_REQUEST,
});

export const configWithServicesSuccess = config => ({
    type: ScheduleTypes.CONFIG_WITH_SERVICES_SUCCESS,
    config
});

export const configWithServicesError = error => ({
    type: ScheduleTypes.CONFIG_WITH_SERVICES_ERROR,
    error
});


export const getConfigWithServices = (context, customerToken, callback = null) => async dispatch => {
    dispatch(configWithServicesLoading());
    const response = await API.getMeetingReservationConfig(context, customerToken, true);
    if (response.ok) {
        dispatch(configWithServicesSuccess(response.data));
    } else {
        dispatch(configWithServicesError(response.error));
    }

    if (callback) {
        callback(response.error, response.ok && response.data)
    }
};

/*** INSTANT OPTIONS ***/
export const instanceOptionsLoading = () => ({
    type: ScheduleTypes.INSTANT_OPTIONS_REQUEST,
});

export const instanceOptionsSuccess = options => ({
    type: ScheduleTypes.INSTANT_OPTIONS_SUCCESS,
    options
});

export const instanceOptionsError = error => ({
    type: ScheduleTypes.INSTANT_OPTIONS_ERROR,
    error
});
export const clearOptionsError = () => ({
    type: ScheduleTypes.OPTIONS_ERROR_CLEAR,
});


export const getInstantOptions = (serviceIds, employeeId) => async dispatch => {
    dispatch(instanceOptionsLoading());
    const {token} = getStateParams();
    const response = await API.getInstantOptions(token, serviceIds, adaptEmployeeId(employeeId));
    if (response.ok) {
        dispatch(instanceOptionsSuccess(response.data));
    } else {
        dispatch(instanceOptionsError(response.error));
    }
};


/*** SPECIFIC OPTIONS ***/
export const specificOptionsLoading = () => ({
    type: ScheduleTypes.SPECIFIC_OPTIONS_REQUEST,
});

export const specificOptionsSuccess = (options, loadMore) => ({
    type: ScheduleTypes.SPECIFIC_OPTIONS_SUCCESS,
    options,
    loadMore
});

export const specificOptionsError = error => ({
    type: ScheduleTypes.SPECIFIC_OPTIONS_ERROR,
    error
});


export const getSpecificOptions = (token, serviceIds, employeeId, dayPart, date, loadMore, existingMode, genderMap, quantityMap) => async dispatch => {
    dispatch(specificOptionsLoading());
    const existingMeetingIds = getSafely(['meetings'], existingMode, []).map((x) => x.MeetingId);
    const response = await API.getSpecificOptions(token, serviceIds, adaptEmployeeId(employeeId), dayPart, date,
        getSafely(['mode'], existingMode), existingMeetingIds, genderMap, quantityMap);
    if (response.ok) {
        dispatch(specificOptionsSuccess(response.data, loadMore));
    } else {
        dispatch(specificOptionsError(response.error));
    }
};


export const setServices = (services) => ({
    type: ScheduleTypes.SET_SERVICES,
    services: services
});

export const setEmployee = (employee) => ({
    type: ScheduleTypes.SET_EMPLOYEE,
    employee
});

export const toggleDayPart = (option) => ({
    type: ScheduleTypes.TOGGLE_DAY_PART,
    option
});

export const setDateOption = (option, date) => ({
    type: ScheduleTypes.SET_DATE_OPTION,
    option, date
});

export const alignDayParts = (dayParts) => ({
    type: ScheduleTypes.ALIGN_DAY_PARTS,
    dayParts
});


/*** SPECIFIC OPTIONS ***/
export const scheduleMeetingRequest = () => ({
    type: ScheduleTypes.SCHEDULE_MEETING_REQUEST,
});

export const scheduleMeetingSuccess = (scheduledMeetings, paymentRequired, url, token, icsUrl, paymentType) => ({
    type: ScheduleTypes.SCHEDULE_MEETING_SUCCESS,
    scheduledMeetings,
    paymentRequired,
    url, token, icsUrl,
    paymentType
});

export const scheduleMeetingError = error => ({
    type: ScheduleTypes.SCHEDULE_MEETING_ERROR,
    error
});


export const scheduleMeeting = (token, serviceIds, employeeId, start, end, internalOptions, roomId, remarks, genderMap, quantityMap, callback) => async dispatch => {
    const {employee_id} = getStateParams();
    const progressValues = getProgressValues();
    dispatch(scheduleMeetingRequest());
    const response = await API.scheduleMeeting(token, serviceIds,
        adaptEmployeeId(employeeId), start, end, getMeetingsToReplace(), internalOptions, roomId, remarks,
        employee_id > 0 ? employee_id : null,
        progressValues, genderMap, quantityMap, getUserSelection()
    );

    let {scheduledMeetings, paymentRequired, url, token: resultToken, icsUrl, paymentType} = response.data;

    if (response.ok) {
        dispatch(scheduleMeetingSuccess(scheduledMeetings, paymentRequired, url, resultToken, icsUrl, paymentType));
    } else {
        dispatch(scheduleMeetingError(response.error));
    }

    if (callback) {
        callback(response.error, {scheduledMeetings, paymentRequired, url, resultToken});
    }
};


/*** REMOVE MEETING ***/
const removeMeetingsRequest = () => ({
    type: ScheduleTypes.REMOVE_MEETINGS_REQUEST,
});

const removeMeetingsSuccess = () => ({
    type: ScheduleTypes.REMOVE_MEETINGS_SUCCESS,
});

const removeMeetingsError = error => ({
    type: ScheduleTypes.REMOVE_MEETINGS_ERROR,
    error
});


export const removeMeetings = (meetings, callback) => async dispatch => {
    const {token} = getStateParams();

    dispatch(removeMeetingsRequest());
    const response = await API.removeMeetings(token, meetings);
    if (response.ok) {
        dispatch(removeMeetingsSuccess(response.data));
    } else {
        dispatch(removeMeetingsError(response.error));
    }

    if (callback) {
        callback(response.error, response.data);
    }
};

/*** RESET ***/
export const resetWizard = () => ({
    type: CommonTypes.WIZARD_RESET,
});


/*** EXISTING MODE ***/
export const setExistingMeetingMode = (mode, meeting) => ({
    type: ScheduleTypes.SET_EXISTING_MEETING_MODE,
    mode,
    meeting
});

export const setExistingMeetingsGroupMode = (mode, group) => ({
    type: ScheduleTypes.SET_EXISTING_MEETINGS_GROUP_MODE,
    mode,
    group
})


export const clearExistingMeetingsMode = () => ({
    type: ScheduleTypes.CLEAR_EXISTING_MEETINGS_MODE,
})

const adaptEmployeeId = (employeeId) => employeeId > 0 ? employeeId : null;

/**** Change Quantity****/

export const changeItemQuantity = (item, addition, simultaneousType) => ({
    type: ScheduleTypes.CHANGE_ITEM_QUANTITY,
    item, addition, simultaneousType
})


export const changeItemGender = (item, genders) => ({
    type: ScheduleTypes.CHANGE_ITEM_GENDER,
    item, genders
})


export const selectServiceCategory = (category) => ({
    type: ScheduleTypes.SELECT_SERVICE_CATEGORY,
    category
})


export const getSession = (token) => async dispatch => {
    dispatch(getSessionRequest());
    const response = await API.getSession(token);

    let {meetings, paymentRequired, url, progressValues, expiresOn, paymentType} = response.data;
    if (response.ok) {
        dispatch(getSessionSuccess(meetings, paymentRequired, url, progressValues, expiresOn, paymentType));
    } else {
        dispatch(getSessionError(response.error));
    }
};

export const getSessionRequest = () => ({
    type: ScheduleTypes.GET_SESSION_REQUEST,
});

export const getSessionSuccess = (scheduledMeetings, paymentRequired, url, progressValues, expiresOn, paymentType) => ({
    type: ScheduleTypes.GET_SESSION_SUCCESS,
    scheduledMeetings,
    paymentRequired,
    paymentType,
    url, progressValues,
    expiresOn
});

export const getSessionError = error => ({
    type: ScheduleTypes.GET_SESSION_ERROR,
    error
});


export const getManifest = (token, contextName, callback) => async dispatch => {
    dispatch(getManifestRequest());
    const response = await API.getManifest(token, contextName);
    if (response.ok) {
        dispatch(getManifestSuccess(response.data));
    } else {
        dispatch(getManifestError(response.error));
    }

    callback(response.data);
};

export const getManifestRequest = () => ({
    type: ScheduleTypes.GET_MANIFEST_REQUEST,
});


export const getManifestSuccess = (manifest) => ({
    type: ScheduleTypes.GET_MANIFEST_SUCCESS,
    manifest
});

export const getManifestError = error => ({
    type: ScheduleTypes.GET_MANIFEST_ERROR,
    error
});


export const cancelSession = (callback) => async dispatch => {
    const {s_token} = getStateParams();
    dispatch(cancelSessionRequest());
    const response = await API.cancelSession(s_token);
    if (response.ok) {
        dispatch(cancelSessionSuccess(response.data));
    } else {
        dispatch(cancelSessionError(response.error));
    }

    callback(response.data);
};

export const cancelSessionRequest = () => ({
    type: ScheduleTypes.CANCEL_SESSION_REQUEST,
});


export const cancelSessionSuccess = (res) => ({
    type: ScheduleTypes.CANCEL_SESSION_SUCCESS,
    res
});

export const cancelSessionError = error => ({
    type: ScheduleTypes.CANCEL_SESSION_ERROR,
    error
});









